export enum LocalStorage {
  PlantId = 'SMSF.PlantId',
  LastAuthUser = 'SMSF.LastAuthUser',
}
